const INFANT_MAX_AGE = 1;

export function isInfant(age: number): boolean {
  return age <= INFANT_MAX_AGE;
}

export function isKid(age: number): boolean {
  return age > INFANT_MAX_AGE;
}
